"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdkInfo = {
  host: 'npmjs.com',
  version: '5.7.2',
  name: 'kentico-cloud-delivery'
};